<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      class="fill-height ma-0"
    >
      <v-stepper
        v-model="step"
        class="flex-fill"
        alt-labels
      >
        <v-stepper-header>
          <v-stepper-step
            :step="stepsList.SHOPPING_CART"
            :complete="stepsDone[stepsList.SHOPPING_CART]"
            complete-icon="mdi-cart"
            edit-icon="mdi-cart"
            editable
          >
            <span class="text-center">Meu carrinho</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :step="stepsList.PAYMENT_METHOD"
            :complete="stepsDone[stepsList.PAYMENT_METHOD]"
            complete-icon="mdi-check"
            edit-icon="mdi-pencil"
          >
            <span class="text-center">Método de pagamento</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :step="stepsList.PAYER_INFO"
            :complete="stepsDone[stepsList.PAYER_INFO]"
            complete-icon="mdi-check"
            edit-icon="mdi-pencil"
          >
            <span class="text-center">Informações do pagador</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :step="stepsList.NFE_INFO"
            :complete="stepsDone[stepsList.NFE_INFO]"
            complete-icon="mdi-check"
            edit-icon="mdi-pencil"
          >
            <span class="text-center">Informações da nota fiscal</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :step="stepsList.PAYMENT_SUMMARY"
            :complete="stepsDone[stepsList.PAYMENT_SUMMARY]"
            complete-icon="mdi-check"
            edit-icon="mdi-pencil"
          >
            <span class="text-center">Resumo da compra</span>
          </v-stepper-step>
        </v-stepper-header>
        <v-row
          justify="center"
          class="ma-0"
        >
          <v-col
            cols="12"
            md="10"
            lg="10"
            xl="8"
          >
            <v-stepper-items>
              <v-stepper-content :step="stepsList.SHOPPING_CART">
                <shopping-cart/>
              </v-stepper-content>
              <v-stepper-content :step="stepsList.PAYMENT_METHOD">
                <payment-method/>
              </v-stepper-content>
              <v-stepper-content :step="stepsList.PAYER_INFO">
                <payer-info/>
              </v-stepper-content>
              <v-stepper-content :step="stepsList.NFE_INFO">
                <nfe-info/>
              </v-stepper-content>
              <v-stepper-content :step="stepsList.PAYMENT_SUMMARY">
                <payment-summary/>
              </v-stepper-content>
            </v-stepper-items>
          </v-col>
        </v-row>
      </v-stepper>
    </v-row>
  </v-container>
</template>

<script>
  import {PAYMENT_STEPS} from "../../helpers/payment/constants"
  import ShoppingCart from "../../components/Payment/ShoppingCart/ShoppingCart"
  import PaymentMethod from "../../components/Payment/PaymentMethod"
  import {paymentMixin} from "../../helpers/payment/mixins"
  import {indexOf} from "lodash/array"
  import PayerInfo from "../../components/Payment/PayerInfo/PayerInfo"
  import NfeInfo from "../../components/Payment/NfeInfo"
  import PaymentSummary from "../../components/Payment/PaymentSummary"

  const PaymentLastStep = Symbol.for("PaymentLastStep")
  const PaymentNextStep = Symbol.for("PaymentNextStep")
  const PaymentSetStep = Symbol.for("PaymentSetStep")

  export default {
    name: "PaymentStepper",
    mixins: [paymentMixin],
    components: {PaymentSummary, PayerInfo, PaymentMethod, ShoppingCart, NfeInfo},
    data: () => ({
      step: 1,
      stepsDone: {},
    }),
    provide() {
      return {
        [PaymentLastStep]: this.lastStep,
        [PaymentNextStep]: this.nextStep,
        [PaymentSetStep]: this.setStep,
      }
    },
    methods: {
      lastStep() {
        const stepsArray = Object.values(PAYMENT_STEPS)
        const currIdx = indexOf(stepsArray, this.step)
        let lastIdx = (currIdx - 1 > -1) ? currIdx - 1 : 0
        this.step = stepsArray[lastIdx]
      },
      nextStep() {
        const stepsArray = Object.values(PAYMENT_STEPS)
        const currIdx = indexOf(stepsArray, this.step)
        let nextIdx = (currIdx + 1 < stepsArray.length) ? currIdx + 1 : stepsArray.length - 1
        this.$set(this.stepsDone, stepsArray[currIdx], true)
        this.step = stepsArray[nextIdx]
      },
      setStep(stepName) {
        const stepsArray = Object.values(PAYMENT_STEPS)
        const stepIndex = indexOf(stepsArray, stepName)
        if (stepIndex === -1) return
        this.step = stepName
        for (let i of [...Array(stepIndex).keys()]) {
          this.$set(this.stepsDone, stepsArray[i], true)
        }
      },
    },
    computed: {
      stepsList() {
        return PAYMENT_STEPS
      }
    },
    created() {
      this.$appMng.setTitle("Meu carrinho")
    }
  }
</script>

<style scoped>

</style>
